import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function IsForYouSection() {
  return <section className="py-8 md:py-10 px-4 bg-slate-950" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <FadeIn className="text-center mb-6" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white tracking-wide" data-id="element-147">
            ✅ ¿ESTE SISTEMA ES PARA VOS?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-148">
          {/* Para vos */}
          <FadeIn delay={0.1} data-id="element-149">
            <div className="bg-slate-900 border border-green-500/30 rounded-2xl p-6 h-full" data-id="element-150">
              <div className="flex items-center gap-3 mb-4 pb-4 border-b border-slate-800" data-id="element-151">
                <CheckCircle2 className="w-8 h-8 text-green-500" data-id="element-152" />
                <h3 className="text-xl font-bold text-white" data-id="element-153">
                  ✅ Este sistema es para vos si...
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-154">
                {['Sos propietario de casa o departamento en Argentina con problema de humedad', 'Querés dejar de comprar pinturas que tapan síntomas y resolver la causa', 'Tenés un taladro y estás dispuesto a dedicar 2 fines de semana a resolver el problema para siempre', 'Querés saber exactamente qué comprar antes de poner un pie en el corralón', 'Querés documentar el trabajo para proteger el valor de tu propiedad'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-155">
                    <span className="text-green-500 mt-1" data-id="element-156">✓</span>
                    <span className="text-slate-300" data-id="element-157">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NO para vos */}
          <FadeIn delay={0.2} data-id="element-158">
            <div className="bg-slate-900 border border-red-500/30 rounded-2xl p-6 h-full" data-id="element-159">
              <div className="flex items-center gap-3 mb-4 pb-4 border-b border-slate-800" data-id="element-160">
                <XCircle className="w-8 h-8 text-red-500" data-id="element-161" />
                <h3 className="text-xl font-bold text-white" data-id="element-162">
                  ❌ Este sistema NO es para vos si...
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-163">
                {['Buscás un curso teórico sobre construcción sin intención de aplicarlo', 'No te interesa hacer nada vos mismo y solo querés contratar a alguien', 'Tenés un problema estructural que requiere evaluación de ingeniero civil'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-164">
                    <span className="text-red-500 mt-1" data-id="element-165">✕</span>
                    <span className="text-slate-300" data-id="element-166">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}